module.exports = __webpack_public_path__ + "static/media/sidebar-collapsed-bg.1d588fb4.jpg";